import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { SessionData, ClassDetail } from '../../Models/Session';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { ModelService } from '../../Services/model.service';
import { SocialLoginService } from '../../Services/social-login.service';
import { AuthResponseModel } from '../../Models/Authentication/AuthResponse';
import { Router } from '@angular/router';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';


@Component({
  selector: 'app-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.css'],standalone:false
})
export class RegisterUserComponent extends BaseComponent implements OnInit{
  items: MenuItem[] | undefined;
  home: MenuItem | undefined;
  userForm!: FormGroup;
  authService: any;
  errorMessage: any;
  imageUrl: string = '';
  loading:boolean=false;
  sessions:SessionData[]=[];
  classes:ClassDetail[]=[];
  languges:any[]=[];
  usernameAvailable: boolean = false;
  loadUsername:boolean=false
  notPresent:boolean=false;
  currentStep: number = 1;
  platform:string='';
  authResponse!:AuthResponseModel;
  loadingapple:boolean=false;
  loadingGoogle:boolean=false;
  constructor(
     private http: HttpClient,
     private auth:AuthService,
     private messageService: ModelService,
     private formBuilder:FormBuilder,
     private api:BaseApiService,
     private appleauth:SocialLoginService,
     private router:Router,
     )
  {
     super ();
     this.appleauth.Getplarform().then(x=>{
        this.platform=x
     })
  }



  noSpacesValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value as string;
    if (value && value.trim().length === 0) {
      return { 'noSpaces': true };
    }
    return null;
  }

  onSubmit(e:Event) {
    e.preventDefault()
    if (this.userForm.valid) {
      this.loading=true;
      const formData = this.userForm.value;
      this.api.create("Auth/RegisterUsers",formData)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        }
      )
      )
      .subscribe(
        {
          next: (response) => {
            this.loading      = false
            this.authResponse = response;
            //setting token avoid login 
            if (this.authResponse.message === "OK")
            {
              const token = this.authResponse.token;
              this.auth.saveToken(token); 
              this.router.navigate(['/ManueDash']);
            } 
            else 
            {
              this.loading=false
              this.messageService.showErrorAlert(this.authResponse.message);
            }
          },
          error:( error) => {
            this.loading=false
            //this.messageService.showErrorAlert(error);
          }
        }
        
      );
    } else {
      this.loading=false
      this.userForm.markAllAsTouched();
    }
  }

  clearFormState() {
    localStorage.removeItem('userFormData');
    localStorage.removeItem('currentStep');
  }
  initilizaform(){
    this.userForm = this.formBuilder.group
    (
      {
           email      : ['', [Validators.required, Validators.email]],
           password   : ['', [Validators.required, Validators.minLength(6)]],
           supCategory: ['Normal User', ],
           subCategory: ['Personal', ],
      }
    );
  }

  isFirstStepValid(): boolean {

    const emailValid = this.userForm.get('email')?.valid;
    const passwordValid = this.userForm.get('password')?.valid;
    const usernameValid = this.userForm.get('username')?.valid;

    return !!emailValid && !!passwordValid && !!usernameValid;
  }

  loadFormState() {
    const savedFormData = localStorage.getItem('userFormData');
    const savedStep = localStorage.getItem('currentStep');
    if (savedFormData && savedStep) {
      this.userForm.setValue(JSON.parse(savedFormData));
      this.currentStep = +savedStep;
    }
  }

  saveFormState() {
    localStorage.setItem('userFormData', JSON.stringify(this.userForm.value));
    localStorage.setItem('currentStep', this.currentStep.toString());
  }

  issecond(): boolean {
    const emailValid    = this.userForm.get('supCategory')?.valid ?? false;
    const passwordValid = this.userForm.get('subCategory')?.valid ?? false;
    return emailValid && passwordValid;
  }



  nextStep() {
    if (this.currentStep <2) {
        this.currentStep++;
        this.saveFormState();
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
        this.currentStep--;
        this.saveFormState();
    }
  }

  //mobile Implemention Apple and Google
  async RegisterWithGoogleMobile(e:Event) 
  {
    try 
   {
      e.preventDefault();
      this.loadingGoogle=true;
      const user = await this.appleauth.googleloginmobile();
      if(user!=null)
      {
        this.RegisterWithSocialWebGooglePlatform(user,this.platform,"Google");
        this.loadingGoogle=false
      }
    } catch (error) 
    {
      this.loadingGoogle=false;
      this.messageService.showErrorAlert("Serveur en panne");
    }
  }

  async RegisterWithAppleMobile(e:Event) 
  {
    try 
   {
      e.preventDefault();
      this.loadingapple=true;
      const user = await this.appleauth.LoginWithAppleNative();
      if(user!=null)
      {
        const userId= user.userId || "N/A";
        const email = user.email || "N/A";
        this.RegisterWithAppleServerRequest(userId,email,this.platform,"Apple");
        this.loadingapple=false
      }
    } catch (error) 
    {
      this.loadingapple=false;
      this.messageService.showErrorAlert("Serveur en panne");
    }
  }

  RegisterWithAppleServerRequest(userId:string,email:string,deviceType:string,platformType:string) 
  {
    this.loadingapple=true;
    this.api.create("Auth/RegisterUsersApple",{email:email,deviceType:deviceType,platformType:platformType,appleUserId:userId}).subscribe(
      (response) => 
      {
        this.authResponse = response;
        this.loadingapple =false
          //setting token avoid login 
          if (this.authResponse.message === "OK")
          {
            this.loadingapple=false
            const token = this.authResponse.token;
            this.auth.saveToken(token); 
            this.router.navigate(['/ManueDash']);

          } 
          else 
          {
            this.loadingapple=false
            this.messageService.showErrorAlert(this.authResponse.message);
          }
          this.loadingapple=false
      },
      ( error) => {
        this.loadingapple=false
        this.messageService.showErrorAlert(error);
      }
    );
  }
  //Web Implemention Apple and Google
  async RegisterWithApple(e:Event) 
  {
    try {
      e.preventDefault();
      this.loadingapple=true;
      const user = await this.appleauth.appleSignInWeb();
      if(user.user!=null){
        const email=user.user.email || "N/A";
        this.RegisterWithSocialWebPlatform(email,this.platform,"Apple");
        this.loadingapple=false;
      }
    } catch (error) 
    {
      this.loadingapple=false;
    }
  }

  async RegisterWithGoogle(e:Event) 
  {
    try 
   {
      e.preventDefault();
      this.loadingGoogle=true;
      const user = await this.appleauth.googleSignInWeb();
      if(user.user!=null){
        const email=user.user.email || "N/A";
        this.loadingGoogle=false
        this.RegisterWithSocialWebGooglePlatform(email,this.platform,"Google");
      }
    } catch (error) 
    { this.loadingGoogle=false
    }
  }

  //Web Implemention
  RegisterWithSocialWebPlatform(email:string,deviceType:string,platformType:string) 
  {
    this.loadingapple=true;
    this.api.create("Auth/RegisterUsersWeb",{email:email,deviceType:deviceType,platformType:platformType}).subscribe(
      (response) => 
      {
          this.authResponse = response;
          this.loadingapple=false //setting token avoid login 
          if (this.authResponse.message === "OK")
          {
            this.loadingapple=false
            const token = this.authResponse.token;
            this.auth.saveToken(token); 
            this.router.navigate(['/ManueDash']);

          } 
          else 
          {
            this.loadingapple=false
            this.messageService.showErrorAlert(this.authResponse.message);
          }
          this.loadingapple=false
      },
      ( error) => {
        this.loadingapple=false
        //this.messageService.showErrorAlert(error);
      }
    );
  }

  RegisterWithSocialWebGooglePlatform(email:string,deviceType:string,platformType:string) 
  {
    this.loadingGoogle=true;
    this.api.create("Auth/RegisterUsersWeb",{email:email,deviceType:deviceType,platformType:platformType})
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loadingGoogle = false;
      }
     )
    )
    .subscribe(
      {
        next:(response) => 
          {
            this.authResponse = response;
              if (this.authResponse.message === "OK")
              {
                this.loadingGoogle =false
                const token        = this.authResponse.token;
                this.auth.saveToken(token); 
                this.router.navigate(['/ManueDash']);
    
              } 
              else 
              {
                this.loadingGoogle=false
                this.messageService.showErrorAlert(this.authResponse.message);
              }
              this.loadingGoogle=false
          },
          error:( error) => {
            this.loadingGoogle=false
            //this.messageService.showErrorAlert(error);
          }
      }      
    );
  }
  ngOnInit() {
    this.initilizaform();

  }
}
